import DashboardView from 'dashboard/DashboardView.react';
import SashiDoLogo from 'components/SashiDoLogo/SashiDoLogo.react';
import ChromeDropdown from 'components/ChromeDropdown/ChromeDropdown.react';
import Button from 'components/Button/Button.react';
import Field from 'components/Field/Field.react';
import Label from 'components/Label/Label.react';
import Icon from 'components/Icon/Icon.react';
import ParseApp from 'lib/ParseApp';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './WhatsNext.scss';
import TextInput from 'components/TextInput/TextInput.react';
import Popover from 'components/Popover/Popover.react';

import StepSDKInfo from './steps/sdkInfo.react';

export default class WhatsNext extends DashboardView {
  constructor() {
    super();
    this.state = {
      checked: true
    }

    this.onCloseClick = this.onCloseClick.bind(this);
    this.handleGoToURLClick = this.handleGoToURLClick.bind(this);
    //this.renderDots = this.renderDots.bind(this);
    this.handleKey = this.handleKey.bind(this);
  }

  componentDidMount() {
    document.body.addEventListener('keydown', this.handleKey);
  }

  componentWillMount() {
    let app = this.context.currentApp

    this.setState({
      appName: app.name
    });
  }

  componentWillUnmount() {
    document.body.removeEventListener('keydown', this.handleKey);
  }

  handleKey(e) {
    var keyCode = e.keyCode || e.which;
    switch (keyCode) {
      case 27:
        this.onCloseClick();
        break;
    }
  }

  onCloseClick() {
    // We need to fix app loading and and set it in the context corretly for this to be this.props.history.push()
    this.props.history.push(`/products/apps/${this.context.currentApp.slug}/browser`);
    // location.href = (`/products/apps/${this.context.currentApp.slug}/browser`);
  }

  handleClick(url) {
    window.open(url, '_blank');
  }

  handleGoToURLClick(value) {
    // this.props.history.push(`/products/apps/${this.context.currentApp.slug}/${value}`);
    // We need to fix app loading and and set it in the context corretly for this to be this.props.history.push()
    location.href = (`/products/apps/${this.context.currentApp.slug}/${value}`);
  }

  // renderDots() {
  //   let views = this.state.views;
  //   let dots = []
  //   for(let i = 0; i<views.length; i++) {
  //     dots.push(
  //       <div
  //         key={views[i] + i}
  //         className={[styles.dot, this.state.originalViews[i] === views[1] ? styles.active : null].join(' ')}>
  //       </div>
  //     );
  //   }

  //   return dots;
  // }

  handGoNext(e) {
    this.setState({
      checked: null
    })
    e.target.checked
  }

  render() {
    let CancelIcon =
      !this.state.migrationLoading
        ?
        <a href='javascript:;' className={styles.iconClose} onClick={this.onCloseClick.bind(this)} >
          <Icon width={16} height={16} name={'icon-close'} />
        </a>
        : null


    let footer = (
      <div className={styles.footer}>
        <div className={styles.dots}>
          {
            //this.renderDots()
          }
        </div>
      </div>
    );

    let playWithDB = (
      <div className={styles.box}>
        <div className={styles.section}>
          <h1>Play With Your Database</h1>
          <p>
            DB Browser is interactive tool, which manages the databases in the backend of the MongoDB.<br />
            Information is collected in the database, organized in a way to easily access, maintain and update it.<br />
          </p>

          <div className={[styles.image, styles.dbBrowser].join(' ')}></div>
          <div className={styles.buttonHolder}>
            <Button
              color='blue'
              value='Go play with and enjoy your database.'
              block={true}
              onClick={this.onCloseClick.bind(this)}
            />
          </div>
        </div>
      </div>
    );

    let pushNotifications = (
      <div className={styles.box}>
        <div className={styles.section}>
          <h1>Setup Push Notifications</h1>
          <p>
            Push notifications are easy and fast way to reach your users, even if they aren’t using the app actively at the moment.<br />
            You have to upload your Apple Push Certificate for iOS and/or enter your GCM/FCM Sender ID and API Key for Android.
          </p>
          <div className={[styles.image, styles.pushSettings].join(' ')}></div>
          <div className={styles.buttonHolder}>
            <Button
              color='blue'
              value='Go to Push Settings'
              block={true}
              onClick={this.handleGoToURLClick.bind(this, 'settings/push')}
            />
          </div>
        </div>
      </div>
    );

    let cloudCode = (
      <div className={styles.box}>
        <div className={styles.section}>
          <h1>Check Your Cloud Code</h1>
          <p>
            Cloud Code is built on the same JavaScript SDK as thousands of mobile Apps.<br />
            This allows you to add new features faster, because you don’t have to wait for a new release of your App.
          </p>
          <div className={[styles.image, styles.cloudCode].join(' ')}></div>
          <div className={styles.buttonHolder}>
            <Button
              color='blue'
              value='See your Cloud Code'
              block={true}
              onClick={this.handleGoToURLClick.bind(this, 'cloud_code')}
            />
          </div>
        </div>
      </div>
    );

    return (
      <Popover modal={true}>
        <div className={[styles.migrate, styles.wn].join(' ')}>
          <div className={styles.showEffect}></div>

          <div className={[styles.slideshow, styles.slideshowProgress].join(' ')}>

            <input value='off' className={styles.checkbox} name="slide" type="radio" id="slide1" checked={this.state.checked} onChange={this.handGoNext.bind(this)} />
            <label className={styles.progress} htmlFor="slide1">
              1. Connect Applications with SashiDo
            </label>
            <div className={styles.slide}>
              <div className={styles.boxHolder}>
                <StepSDKInfo app={this.context.currentApp} />
              </div>
            </div>

            <input value='off' className={styles.checkbox} name="slide" type="radio" id="slide2" onChange={this.handGoNext.bind(this)} />
            <label className={styles.progress} htmlFor="slide2">
              2. Play With Your Database
            </label>
            <div className={styles.slide}>
              <div className={styles.boxHolder}>
                {playWithDB}
              </div>
            </div>

            <input value='off' className={styles.checkbox} name="slide" type="radio" id="slide3" onChange={this.handGoNext.bind(this)} />
            <label className={styles.progress} htmlFor="slide3">
              3. Setup Push Notifications
            </label>
            <div className={styles.slide}>
              <div className={styles.boxHolder}>
                {pushNotifications}
              </div>
            </div>

            <input value='off' className={styles.checkbox} name="slide" type="radio" id="slide4" onChange={this.handGoNext.bind(this)} />
            <label className={styles.progress} htmlFor="slide4">
              4. Check Your Cloud Code
            </label>
            <div className={styles.slide}>
              <div className={styles.boxHolder}>
                {cloudCode}
              </div>
            </div>

            <span className={styles.progress} onClick={this.onCloseClick.bind(this)}>
              Go to {this.state.appName}
            </span>
          </div>

          <SashiDoLogo />
          {CancelIcon}
        </div>
      </Popover>
    );
  }
}

WhatsNext.contextTypes = {
  currentApp: PropTypes.instanceOf(ParseApp)
};
